import { DEFAULT_STATE } from './User.state';

const INITIAL_STATE = DEFAULT_STATE;

const UserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default UserReducer;
